import { InvalidRowState } from "./types";
import { XactimateBadge } from "./shared";

export interface InvalidMappingRowProps {
    row: InvalidRowState;
    validPermutations: string[];
    onReplacementChange: (value: string) => void;
    onUpdate: () => void;
    onDelete: () => void;
}

export const InvalidMappingRow = ({ row, validPermutations, onReplacementChange, onUpdate, onDelete }: InvalidMappingRowProps) => (
    <div className="border rounded-lg p-3 bg-red-50 border-red-200">
        <p className="text-sm text-stone-600 mb-1">
            <span className="text-xs text-stone-400 mr-1">Was:</span>
            <span className="line-through text-red-600 font-mono text-xs">
                {row.mapping.acceptedLineString}
            </span>
        </p>
        <XactimateBadge mapping={row.mapping} />
        <div className="flex items-center gap-2 mt-3 flex-wrap">
            <label className="text-xs text-stone-500 shrink-0">Replace with:</label>
            <select
                className="border rounded px-2 py-1 text-xs flex-1 min-w-0"
                value={row.selectedReplacement}
                onChange={(e) => onReplacementChange(e.target.value)}
            >
                {validPermutations.map((p) => (
                    <option key={p} value={p}>
                        {p}
                    </option>
                ))}
            </select>
            <button
                className="btn rounded bg-indigo-600 text-white text-xs px-3 py-1 disabled:opacity-50"
                onClick={onUpdate}
                disabled={row.saving || !row.selectedReplacement}
            >
                {row.saving ? "Saving…" : "Update"}
            </button>
            <button
                className="btn rounded bg-red-500 text-white text-xs px-3 py-1"
                onClick={onDelete}
            >
                Delete
            </button>
        </div>
    </div>
);
